import { BUTTONS } from 'wix-rich-content-plugin-commons';
import { getModalStyles, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import getModalCustomStyles from './ModalCustomStyles.js';
import VerticalEmbedInputModal from './VerticalEmbedInputModal.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DesktopFlyOutModalStyles } from 'wix-rich-content-ui-components';
import { modalContentStyles } from '../constants.js';
import ReplaceIcon from '../icons/ReplaceIcon.js';
import 'prop-types';
import 'react';
import './VerticalEmbedInsertModal.js';
import '../ItemsList-09cdb7f4.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import './itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../convertDuration.js';
import 'lodash';
import '../types.js';
import 'wix-rich-content-common';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInlineButtons = ({
  t,
  isMobile,
  settings,
  locale,
  experiments = {}
}) => {
  const { newVideoVerticalAndSocialModals } = experiments;
  const useNewModal = newVideoVerticalAndSocialModals == null ? void 0 : newVideoVerticalAndSocialModals.enabled;
  const newModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: modalContentStyles });
  const customStyles = useNewModal ? newModalCustomStyles : getModalCustomStyles(isMobile);
  const defaultModalStyles = getModalStyles({
    customStyles,
    fullScreen: !!useNewModal,
    isMobile
  });
  const newModalStyles = isMobile ? defaultModalStyles : void 0;
  const modalStyles = useNewModal ? newModalStyles : defaultModalStyles;
  return [
    {
      keyName: "replace",
      type: BUTTONS.EXTERNAL_MODAL,
      icon: ReplaceIcon,
      modalElement: decorateComponentWithProps(VerticalEmbedInputModal, __spreadProps(__spreadValues({}, settings), { locale })),
      modalStyles,
      mobile: true,
      tooltipTextKey: "Replace product",
      t,
      modalStylesFn: useNewModal ? ({ buttonRef }) => {
        const modalStyles2 = getModalStyles({
          customStyles: newModalCustomStyles,
          fullScreen: true,
          isMobile
        });
        const modalHeight = modalContentStyles.height;
        const { top, left } = buttonRef.getBoundingClientRect();
        const modalLeft = left - 15;
        const heightLeftBelow = (window == null ? void 0 : window.innerHeight) - (top + 40);
        const dynamicModalTop = heightLeftBelow < modalHeight ? modalHeight - heightLeftBelow : top + 40;
        const modalTop = top > modalHeight ? top - 540 : dynamicModalTop;
        return __spreadProps(__spreadValues({}, modalStyles2), {
          content: __spreadProps(__spreadValues({}, modalStyles2.content), {
            top: modalTop,
            left: modalLeft,
            margin: 0,
            position: "absolute"
          })
        });
      } : void 0
    },
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
